module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_8011.35482f02.png";